import { useMediaQuery } from "../use-media-query"

type Breakpoint = "sm" | "md" | "lg" | "xl"

const breakpoints: Record<Breakpoint, number> = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1440,
}

/**
 * A hook that returns whether the current viewport width matches or exceeds a specified breakpoint.
 *
 * @param breakpoint - The breakpoint to check against.
 * @returns True if the viewport width is greater than or equal to the specified breakpoint, false otherwise.
 *
 * @example
 * ```tsx
 * function ResponsiveComponent() {
 *   const isLargeScreen = useMediaBreakpoint('lg');
 *
 *   return (
 *     <div>
 *       {isLargeScreen ? 'Large Screen Content' : 'Small Screen Content'}
 *     </div>
 *   );
 * }
 * ```
 */
export function useMediaBreakpoint(breakpoint: Breakpoint): boolean {
  if (!breakpoints[breakpoint]) {
    console.error("Invalid breakpoint", breakpoint)
  }

  return useMediaQuery(`(min-width: ${breakpoints[breakpoint]}px)`)
}
